import { render, staticRenderFns } from "./UserIdUpload.vue?vue&type=template&id=dedf84a2&scoped=true&"
import script from "./UserIdUpload.vue?vue&type=script&lang=js&"
export * from "./UserIdUpload.vue?vue&type=script&lang=js&"
import style0 from "./UserIdUpload.vue?vue&type=style&index=0&id=dedf84a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedf84a2",
  null
  
)

export default component.exports